module.exports = __webpack_public_path__ + "img/study-pro2.52a50260.png";